import {
  UPDATE_LINKEDIN_BANNER_REQUEST,
  UPDATE_LINKEDIN_BANNER_SUCCESS,
  UPDATE_LINKEDIN_BANNER_FAILURE,
  RESET_LINKEDIN_BANNER_STATE,
} from "../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
};

const updateLinkedinBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LINKEDIN_BANNER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_LINKEDIN_BANNER_SUCCESS:
      console.log("response", action.payload);
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case UPDATE_LINKEDIN_BANNER_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case RESET_LINKEDIN_BANNER_STATE:
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default updateLinkedinBannerReducer;
